import { render } from "./SectionSteps.vue?vue&type=template&id=5f254fe1"
import script from "./SectionSteps.vue?vue&type=script&lang=js"
export * from "./SectionSteps.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__